// deps
import { useCallback, useContext, useEffect, useState } from "react";

// contexts
import { CartContext } from "@cart-client/contexts/CartContext";
import { CartToastContext } from "@cart-client/contexts/CartToastContext";
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// analytics
import { impressionMagicItemsOfferLimit } from "@cart-client/analytics/events";

export interface UseCartItemRendererReturnType {
    onDisabledIncrementItemQtyClick: VoidFunction;
    onImpressionMagicItemsOfferLimit: (itemId: string, qty: number) => void;
}

export function useCartItemrenderer(): UseCartItemRendererReturnType {
    const {
        cartState: { reviewedCart },
    } = useContext(CartContext);
    const { setCartToastData } = useContext(CartToastContext);
    const { impressionEvent } = useContext(AnalyticsContext);

    const dealsMessageInfo = reviewedCart?.data?.deals_message_info;
    const [limitExceededMessageShown, setLimitExceededMessageShown] = useState(false);

    const onDisabledIncrementItemQtyClick = useCallback(() => {
        if (!dealsMessageInfo || dealsMessageInfo["limit_reached_message"] == null) {
            return;
        }
        setCartToastData({ message: dealsMessageInfo["limit_reached_message"], show: true });
    }, [dealsMessageInfo, setCartToastData]);

    useEffect(() => {
        if (!dealsMessageInfo || dealsMessageInfo["limit_exceeded_message"] == null || limitExceededMessageShown) {
            return;
        }
        setCartToastData({ message: dealsMessageInfo["limit_exceeded_message"], show: true });

        // this message to be shown only once on cart load. Hence saving shown status after setting toast data
        setLimitExceededMessageShown(true);
    }, [dealsMessageInfo, limitExceededMessageShown, setCartToastData]);

    const onImpressionMagicItemsOfferLimit = useCallback(
        (itemId: string, qty: number) => {
            impressionMagicItemsOfferLimit(impressionEvent, {
                cartId: String(reviewedCart?.data?.cartId),
                itemId,
                qty,
            });
        },
        [impressionEvent, reviewedCart?.data?.cartId],
    );

    return { onDisabledIncrementItemQtyClick, onImpressionMagicItemsOfferLimit };
}
